import React from 'react'
import './Input.css';
import '../Theme.css';

function Input({style, type, text, placeholder, onTextChanged, disabled = false, onEnterPressed}) {

    const onChange = (event) => {
        let text = event.target.value;
        onTextChanged(text);
    }

    const onKeyPress = (event) => {
        if (event.charCode === 13 && !event.shiftKey) {
            if (onEnterPressed) onEnterPressed();
        }
    }

    let className = "Input " + style;

    return (
        <input className={className}
               disabled={disabled}
               type={type}
               value={text}
               onKeyPress={onKeyPress}
               placeholder={placeholder}
               onChange={onChange}/>
    )
}

export default Input;
